import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Faz fetch do usuário apenas se houver token válido
  const fetchUser = async (token) => {
    try {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.get('/api/auth/me');
      setUser(response.data);
    } catch (error) {
      setUser(null);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    const expStr = localStorage.getItem('token_exp');
    const exp = expStr ? parseInt(expStr, 10) : 0;

    if (token && exp && Date.now() < exp) {
      fetchUser(token);
    } else {
      // expirada ou inexistente
      localStorage.removeItem('token');
      localStorage.removeItem('token_exp');
      setLoading(false);
    }

    // Escutar evento de logout do interceptor
    const handleAuthLogout = () => {
      setUser(null);
      setLoading(false);
    };

    window.addEventListener('auth-logout', handleAuthLogout);
    
    return () => {
      window.removeEventListener('auth-logout', handleAuthLogout);
    };
  }, []);

  const TOKEN_TTL_MS = 2 * 60 * 60 * 1000; // 2 horas

  const login = async (email, password) => {
    try {
      const response = await axios.post('/api/auth/login', { email, password });
      const { token: newToken, user: userData } = response.data;

      const exp = Date.now() + TOKEN_TTL_MS;
      localStorage.setItem('token', newToken);
      localStorage.setItem('token_exp', String(exp));
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

      setUser(userData);
      return { success: true };
    } catch (err) {
      // Garantir que não há mudanças de estado desnecessárias
      console.log('Erro no login:', err.response?.status, err.response?.data);
      
      if (err.response?.status === 401) {
        return { success: false, message: 'Usuário ou senha incorretos' };
      }
      return { success: false, message: 'Erro ao fazer login' };
    }
  };

  const register = async (userData) => {
    try {
      const response = await axios.post('/api/auth/register', userData);
      const { token: newToken, user: newUser } = response.data;

      const exp = Date.now() + TOKEN_TTL_MS;
      localStorage.setItem('token', newToken);
      localStorage.setItem('token_exp', String(exp));
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

      setUser(newUser);
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || 'Erro ao registrar' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('token_exp');
    delete axios.defaults.headers.common['Authorization'];
  };

  const isAdmin = () => {
    return user?.email === 'Admin@saocristovao.com.br';
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
